import { CTAAnchor, CTALink } from "@hermes/api-model-common";
import { Media } from "@hermes/api-model-editorial";
import { Locale } from "@hermes/locale";

const RETOUCHED_IMAGE = $localize`:@@hermes.image_retouched:Retouched`;

export function getMediaName(media: Media): string {
    // Get name from media url
    const nameFromUrl = media.videoUrl
        ? media.videoUrl.split("name=").pop()
        : "";
    let videoName = "";

    if (nameFromUrl) {
        // Some case, media url look like V_169_FW15_Cherche_Midi-AVS&end.
        // Remove all parameter after &
        videoName = nameFromUrl.slice(0, nameFromUrl.indexOf("&"));
    }

    return videoName;
}

export function showFigureCaption(media: Media, locale: Locale): boolean {
    // Written this way because we want to return the evaluate boolean value of the condition, not the value of one of its elements (that could be a string).
    // Also written this way because of an ESlint rule.
    return (
        (media?.imageRetouched === true && locale.countryCode === "fr") ||
        !!media?.caption ||
        !!media?.credits
    );
}

export function setMediaImageAltFromCTA(
    media: Media,
    cta: CTALink | CTAAnchor | undefined,
): Media {
    if (!media?.imageAlt && cta?.text) {
        return { ...media, imageAlt: cta.text };
    }
    return media;
}

export function displayAriaLabel(
    media: Media,
    title: string | undefined,
): string | undefined {
    const { imageRetouched, caption, credits } = media;
    const retouchedLabel = imageRetouched ? `${RETOUCHED_IMAGE} ` : "";

    if (caption || credits) {
        return `${retouchedLabel}${caption ?? ""}${
            credits ? ` ${credits}` : ""
        }`;
    }

    return retouchedLabel || title || undefined;
}

export function shouldDisplayOverlayText(media: Media): boolean {
    return Boolean(
        media.title ||
        media.description ||
        (media.shouldDisplayCta && media.token),
    );
}
